import React from "react";

/* Official Maya wordmark. Two hosted variants:
 *   - default: transparent PNG (best over coloured/blue backgrounds)
 *   - onWhite: solid white background (best on light UI)
 */
export const MAYA_LOGO_TRANSPARENT =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_medily-pro/artifacts/2crv9cvs_Maya%20%28without%20white%20background%29.png";
export const MAYA_LOGO_ON_WHITE =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_medily-pro/artifacts/70b67el4_Maya.png";

/* Adaptive Maya logo. Pass `variant="on-blue"` when placing on a coloured
 * background (uses the transparent asset). Default `on-white` uses the
 * solid-white-background asset which renders cleanly on light UI. */
const MayaLogo = ({ variant = "on-white", className = "", style, alt = "Maya" }) => {
  // Both assets are transparent with a blue wordmark. On coloured backgrounds we
  // invert to render as white; on light backgrounds we keep the original blue.
  const invert = variant === "on-blue";
  return (
    <img
      src={MAYA_LOGO_TRANSPARENT}
      alt={alt}
      className={className}
      style={{
        userSelect: "none",
        filter: invert ? "brightness(0) invert(1)" : undefined,
        ...style,
      }}
      draggable={false}
    />
  );
};

export default MayaLogo;
